import store from 'store';
import utils from 'common/utils';

const fallbackCtxVar = [
  'LOGIN_UID',
  'MT_GUID',
  'MT_TOKEN',
];
function sessionSupported() {
  const mt = 'maitao';
  try {
    sessionStorage.setItem(mt, mt);
    sessionStorage.removeItem(mt);
    return true;
  } catch (e) {
    return false;
  }
}
function set(key, value, notPersistent) {
  if (value) {
    value = JSON.stringify(value);
  }
  // if (Array.isArray(value)) {
  //   value = `arr_${qs.stringify(value)}`;
  // }
  if (!notPersistent) {
    store.set(key, value);
    if (fallbackCtxVar.includes(key)) {
      setCookie(key, value, 365);
    }
  } else if (sessionSupported()) {
    sessionStorage.setItem(key, value);
  } else {
    console.warn('sorry, session not supported');
  }
}
function get(key, notPersistent) {
  let value = null;
  if (!notPersistent) {
    value = store.get(key);
    if (!value && fallbackCtxVar.includes(key)) {
      value = getCookie(key);
    }
  } else if (sessionSupported()) {
    value = sessionStorage.getItem(key);
  } else {
    console.warn('sorry, session not supported');
  }
  if (value) {
    value = JSON.parse(value);
  }
  return value;
}
function remove(key, notPersistent) {
  if (notPersistent) {
    sessionStorage.removeItem(key);
  } else {
    store.remove(key);
    if (fallbackCtxVar.includes(key)) {
      removeCookie(key);
    }
  }
}
function getGuid() {
  let guid = get('MT_GUID');
  if (utils.isEmpty(guid)) {
    guid = utils.uuidGenerator();
    set('MT_GUID', guid);
  }
  return guid;
}
function clearGuid() {
  store.remove('MT_GUID');
}
function getCookie(sKey) {
  return decodeURIComponent(document.cookie.replace(new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')) || null;
}
/* eslint no-useless-escape: 0 */
function setCookie(sKey, sValue, vAge) {
  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
  const sExpires = `;max-age=${vAge * 24 * 60 * 60}`;
  document.cookie = `${encodeURIComponent(sKey)}=${encodeURIComponent(sValue)}${sExpires};path=/`;
  return true;
}
function removeCookie(sKey) {
  if (!sKey) { return false; }
  document.cookie = `${encodeURIComponent(sKey)}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  return true;
}
export default {
  set,
  get,
  remove,
  getGuid,
  clearGuid,
  LOGIN_UID: 'LOGIN_UID',
  LOGIN_ENCRYPTED_UID: 'LOGIN_ENCRYPTED_UID',
};
